<template>
  <SectionContainer @edit="$emit('edit')" :hideEdit="hideEdit" :showEdit="showEditComputed" :showAdd="showAddComputed">

    <!-- Social Profiles Section -->
    <InfoRow :label="t('profile.social_profiles')" v-if="mappedSocialProfiles.length && showSocialProfiles" class="!mb-[18px]">
      <div v-for="profile in mappedSocialProfiles" :key="profile.key" class="!pt-[4px] pb-[4px] flex items-center">
        <img
          :src="`/images/social/${profile.icon}`"
          :alt="profile.name"
          class="w-[16px] h-[16px] mr-2"
        />
        <a :href="profile.link" target="_blank" rel="noopener noreferrer" class="font-bold text-black">
          {{ profile.name }}
        </a>
      </div>
    </InfoRow>

    <template v-if="hasDeclaration">

      <InfoRow :label="t('profile.declarant')" v-if="declaration.name_of_declarant">
        <p>{{ declaration.name_of_declarant }}</p>
      </InfoRow>

      <InfoRow :label="t('profile.date_of_declaration')" v-if="declaration.date_of_declaration">
        <p>{{ declaration.date_of_declaration }}</p>
      </InfoRow>

      <InfoRow :label="t('profile.main_workplace')" v-if="declaration.main_workplace">
        <p>{{ declaration.main_workplace }}</p>
      </InfoRow>

      <InfoRow :label="t('profile.shares')" v-if="declaration.shares">
        <p>{{ declaration.shares }}</p>
      </InfoRow>

      <InfoRow :label="t('profile.spouse')" v-if="declaration.spouse">
        <p>{{ declaration.spouse }}</p>
      </InfoRow>

    </template>

  </SectionContainer>
</template>

<script setup>
import { computed } from "vue";
import SectionContainer from "@/components/account/sections/SectionContainer.vue";
import InfoRow from "@/components/content/InfoRow.vue";
const { t } = useI18n();

const props = defineProps({
  socialProfiles: {
    type: Array,
    default: () => []
  },
  showSocialProfilesPublicly: {
    type: Boolean,
    default: true
  },
  onboardingData: {
    type: Object,
    default: () => ({}),
  },
  declaration: {
    type: Object,
    default: () => ({}),
  },
  hasDeclaration: {
    type: Boolean,
    default: false
  },
  showEdit: {
    type: Boolean,
    default: true
  },
  hideEdit: {
    type: Boolean,
    default: false
  },
  showSocialProfiles: {
    type: Boolean,
    default: true
  },
});

// Computed property to map socialProfiles with onboardingData.social_profiles
const mappedSocialProfiles = computed(() => {
  const onboardingProfiles = props.onboardingData.social_profiles || [];

  return props.socialProfiles.map((userProfile) => {
    const onboardingProfile = onboardingProfiles.find(
      (profile) => profile.key === userProfile.key
    );
    if (onboardingProfile) {
      return {
        ...onboardingProfile,
        link: userProfile.link
      };
    }
    return null;
  }).filter(profile => profile !== null && profile.link); // Filter out profiles with no link
});

// Computed property to determine if showEdit should be true
const showEditComputed = computed(() => {
  return mappedSocialProfiles.value.length > 0 || props.hasDeclaration;
});

// Computed property to determine if showAdd should be true
const showAddComputed = computed(() => {
  return mappedSocialProfiles.value.length === 0 && !props.hasDeclaration;
});
</script>

<style scoped>
/* Add any custom styles as needed */
</style>
